<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
                <h2 class="tw-capitalize tw-text-secondary">
                    {{ mode }} Base dues
                </h2>
            <v-form name="editForm" ref="editForm">
                <div>
                    <div class="tw-flex tw-flex-row tw-gap-2">
                        <!-- Due Date -->
                        <date-picker
                            v-model="modelObject.date_due"
                            color="primary"
                            display-label="Due Date"
                            :rules="[rules.required]"
                            dense
                        />
                        <!-- Current Year (Read only from the due date) -->
                        <v-text-field
                            v-show="is_edit_mode"
                            :value="getCurrentYearFromDueDate(modelObject.date_due)"
                            label="Current Year"
                            readonly
                            dense
                        />
                        <!-- Payment Date -->
                        <date-picker
                            v-model="modelObject.date_payment"
                            color="primary"
                            display-label="Payment Date"
                            dense
                        />
                    </div>
                    <!-- Item Paid drop down list -->
                    <v-select
                        v-model="modelObject.paid_item"
                        :items="valuelists.DUES_ITEMS"
                        label="Item Paid"
                        color="primary"
                        :rules="[rules.required]"
                    />
                    <div class="tw-flex tw-flex-row tw-gap-2">
                        <v-select
                            v-model="modelObject.type_payment"
                            :items="valuelists.DUES_PAYMENT_TYPES"
                            label="Payment mode"
                            color="primary"
                        />

                        <v-text-field
                            v-model="modelObject.check_number"
                            label="Cheque / Bank"
                            color="primary"
                        />
                    </div>

                    <!-- Deposit Date -->
                    <date-picker
                        v-model="modelObject.date_deposit"
                        color="primary"
                        display-label="Deposit Date"
                        dense
                    />
                    <div class="tw-flex tw-flex-row tw-gap-2">
                        <!-- Due -->
                        <v-text-field
                            v-model="modelObject.amount_due"
                            label="Due"
                            color="primary"
                            type="number"
                            step="0.01"
                            :rules="modelObject.amount_due ? decimalRuleAllowNegative : []"
                        ></v-text-field>

                        <!-- Payment -->
                        <v-text-field
                            v-model="modelObject.amount_payment"
                            label="Payment"
                            color="primary"
                            type="number"
                            step="0.01"
                            :rules="modelObject.amount_payment ? decimalRuleAllowNegative : []"
                        ></v-text-field>
                    </div>

                </div>
            </v-form>
                <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">
                    <v-btn
                        text
                        @click="archiveModel()"
                        :loading="archiveLoading"
                        v-show="is_edit_mode"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        text
                        @click="cancelDialog"
                        class="main-btn"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        text
                        @click="saveModel"
                        class="main-btn"
                        :loading="saveLoading"
                    >
                        Save
                    </v-btn>

                </div>
            </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker";
import WYSIWYG from "@/Generic/WYSIWYG";

export default {
    name: "EditBaseDuesModal",
    components: {
        DatePicker,

    },
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            required: true
        },
        'modelProp': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Object,
            required: false
        },
        'memberId': {
            // The model we want to show details for (model is generic and don't require to be modified for each reuse of this modal)
            type: Number,
            required: false
        },
        'valuelists': {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            dialog: this.value || false,
            // valuelist: this.valuelists,
            skill: undefined,
            member_id: this.memberId || '',
            mode: 'Add',
            modelObject: this.modelProp || {},
            modelDefault: {
                id: null,
                date_due: new Date().toISOString().split('T')[0],
            },
            saveLoading: false,
            rules: {
                required: value => !!value || 'Required',
            },
            archiveLoading: false,
            valuelist: {
                paid_item: [
                    "Application Fees",
                    "Back Per Capita",
                    "Base Dues",
                    "Cineplex",
                    "Dues Discount",
                    "Dues Refund",
                    "E-Board",
                    "Event Deposit",
                    "Event Deposit Refund",
                    "Initiation Fees",
                    "Medical/Parental Leave",
                    "Miscellaneous",
                    "NSF Fee",
                    "Reinstatement Fee"
                ],
                type_payment: [
                    "Square",
                    "Debit",
                    "Visa",
                    "Mastercard",
                    "Cheque",
                    "Internet Bank"
                ],
            },
            }
    },
    mounted() {

    },
    computed: {
        dialog_width() {
            return '400px'
        },
        is_edit_mode() {
            return this.mode == 'Edit' ? true : false
        },
        positiveDecimalRule() {
            return [
                (value) => /^\d+(\.\d{1,2})?$/.test(value) || 'Invalid format', // Decimal format rule
                (value) => value >= 0 || 'Value cannot be negative', // Non-negative rule
            ];
        },
        decimalRuleAllowNegative() {
            return [
                (value) => /^-?\d+(\.\d{1,2})?$/.test(value) || 'Invalid format', // Decimal format rule allow negative
            ];
        },
    },
    methods: {
        getCurrentYearFromDueDate(date) {
            if (!date) return ''
            const [year, month, day] = date.split("-").map(Number);
            const timezone_adjusted = new Date(year, month - 1, day); // Month is zero-based


            return new Date(timezone_adjusted).getFullYear();
        },
        activeOption(option) {
            if( this.activeOptions.includes(option) ){
                return true
            }
            return false
        },
        resetModel() {
            this.modelObject = structuredClone(this.modelDefault)
        },
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },

        saveModel() {
            let payload = this.modelObject

            if (!this.$refs.editForm.validate()) {
                this.$root.snackbar.error('Please fill all required fields.')
                return false
            }

            if (!this.is_edit_mode) {
                payload.user_id = this.member_id;
            }

            let url = route('membersdues.store')

            if (this.is_edit_mode) {
                url = route('membersdues.update', this.modelObject.id)
                payload._method = "put"
            }

            axios({
                method: 'post',
                url: url,
                data: payload,
                onUploadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
                onDownloadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.is_dirty = false
                        this.$root.snackbar.success('Changes have been saved')
                        this.dialog = false
                        this.$root.is_dirty = false
                        this.saveLoading = false
                        this.$emit('successful-save')
                    } else if (response.data?.error) {
                        throw (response.data?.error)
                    } else {
                        throw ('Unknown error.')
                    }
                })
                .catch((error) => {
                    if (error?.response) {
                        this.$root.snackbar.error(error.response.data.message)
                        this.errors = error.response?.data?.errors
                    } else {
                        console.log(error)
                        this.$root.snackbar.error(error)
                    }
                    this.saveLoading = false
                })

        },

        async archiveModel()
        {
            if (await this.$root.confirm.open(`Delete Base due?`, `You are about to delete Base due from ${this.modelObject.date_due}`)) {

                let method = 'delete'
                let url = route('membersdues.destroy', this.modelObject.id)
                let payload = this.modelObject

                axios({
                    method: method,
                    url: url,
                    data: payload,
                    onUploadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.archiveLoading = !this.archiveLoading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Base due has been deleted')
                            this.dialog = false
                            this.$root.is_dirty = false
                            this.archiveLoading = false
                            this.$emit('successful-save')
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        this.$root.snackbar.error(error.response.data.message)
                        this.archiveLoading = false
                    })
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {

            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.activeEditor1 = false
                this.$refs.editForm.resetValidation()
            } else {
                // Opening modal
                if (this.modelProp === null) {
                    this.mode = 'Add'
                    this.modelObject = structuredClone(this.modelDefault)
                } else {
                    this.mode = 'Edit'
                    this.modelObject = structuredClone(JSON.parse(JSON.stringify(this.modelProp)))
                    if (typeof this.$refs.datePicker !== 'undefined'){
                        this.$refs.datePicker.date_temp = this.modelObject.date_course
                    }
                    if (typeof this.$refs.datePicker2 !== 'undefined'){
                        this.$refs.datePicker2.date_temp = this.modelObject.date_expire
                    }
                }
            }
        },
        'modelObject.date_course'(newDate) {
            if (typeof this.$refs.datePicker !== 'undefined'){
                this.$refs.datePicker.date_temp = newDate
            }
        },
        'modelObject.date_expire'(newDate) {
            if (typeof this.$refs.datePicker2 !== 'undefined'){
                this.$refs.datePicker2.date_temp = newDate
            }
        },
        // modelProp: {
        //     handler(newVal) {
        //         this.skill = newVal?.skill?.id
        //         this.modelObject = newVal || {}; // Update modelObject when modelProp changes
        //     },
        //     immediate: true // Trigger the watcher immediately when the component is created
        // },

    },
}
</script>
<style scoped>
</style>
